var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "#e84135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M538.33-502.06q23.67-23.39 23.67-58t-23.73-58.27Q514.55-642 479.94-642T422-618.27q-23.33 23.72-23.33 58.33T422.06-502q23.39 23.33 58 23.33t58.27-23.39ZM480-52Q305.67-197 218.83-316.67 132-436.33 132-555.33q0-161.34 105.33-257.34 105.34-96 242.67-96 137.33 0 243 96 105.67 96 105.67 257.34 0 119-87.17 238.66Q654.33-197 480-52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map_marker.32d9a601295e3296398e46079b6e42ba.svg";
export { ForwardRef as ReactComponent };